export default __webpack_public_path__ + "static/media/1.229dc5b6.png";